import { Link } from "react-router-dom";
import { Redirect } from "react-router";
import { DetailEntity } from "../services";

import Footer from "./_general/Footer";
import Icon from "@identitybuilding/idb-react-iconlib";
import Meta from "./_general/Meta";
import Navigation from "./_general/Navigation";
import React, { useEffect, useState, Suspense, lazy } from "react";
// import SearchBar from "./search/SearchBar";
import Redirects from "./_general/Redirects";
import Slider from "react-slick";
import Placeholder from "../library/imgs/logo_placeholder.png";
import Axios from "axios";
import { useLocation, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// import ActivitiesServices from "@identitybuilding/idb-react-activities-services";
// import Brands from "@identitybuilding/idb-react-brands";
import Contact from "@identitybuilding/idb-react-contact";
import Relations from "@identitybuilding/idb-react-relations";
import SocialMedia from "@identitybuilding/idb-react-contact/dist/components/SocialMedia";
import axios from "axios";
import { fetchAdvertisementsForEstablishment } from "../utils/advertisements";
import AdvertisementCard from "./Advertisements/AdvertisementCard";
import { getEnvEndpoints } from "../utils/functions";

// import CurrentOffers from "@identitybuilding/idb-react-current-offers";
// import DigitalDisplay from "@identitybuilding/idb-react-digital-display";
// import Video from "@identitybuilding/idb-react-video-library";

const SearchBar = lazy(() => import("./search/SearchBar"));
const ActivitiesServices = lazy(() =>
  import("@identitybuilding/idb-react-activities-services")
);
const Brands = lazy(() => import("@identitybuilding/idb-react-brands"));
const CurrentOffers = lazy(() =>
  import("@identitybuilding/idb-react-current-offers")
);
const DigitalDisplay = lazy(() =>
  import("@identitybuilding/idb-react-digital-display")
);

// cookies
var engine = require("store/src/store-engine");
var storages = [require("store/storages/cookieStorage")];
var plugins = [
  require("store/plugins/defaults"),
  require("store/plugins/expire"),
];
var store = engine.createStore(storages, plugins);

const AlternateBusinessPage = (props) => {
  const [drawer, setDrawer] = useState(false);
  const [entity, setEntity] = useState({ business: true, data: {}, views: [] });
  const [prevPath, setPrevPath] = useState(false);
  const [Zindex, setZindex] = useState(false);
  const [bpIndex, setBpIndex] = useState("all");
  const [contactTab, setContactTab] = useState(0);
  const [contactView, setContactView] = useState("");
  const [relations, setRelations] = useState([])

  const [error, setError] = useState({ error_active: "", redirect: false });

  const [facilities, setFacilities] = useState("");
  const [persons, setPersons] = useState([]);
  const [creadCollections, setCreadCollections] = useState([]);
  const [cmpsCollections, setCmpsCollections] = useState([]);
  const [brands, setBrands] = useState([]);
  const [activities, setActivities] = useState([]);

  const [sendMail, setSendMail] = useState(false);

  const [loadingAds, setLoadingAds] = useState(true);
  const [advertisementBanners, setAdvertisementBanners] = useState([]);

  const env = getEnvEndpoints()
  // let categoryID = useSelector((state) => state.search.as_category);
  // let serviceFilter = useSelector((state) => state.search.serviceFilter);

  const params = props.location.search;
  const lang = useSelector((state) => state.general.lang);
  const map = useSelector((state) => state.map);
  
  const translate = useSelector((state) => state.general.translate);
  const id = props.match && props.match.params.id;
  const mod = props.match && props.match.params.mod;
  const is100ProcentLokaal = window.location.href.includes('100procentlokaal') || window.location.href.includes('100pourcentlocale');

  const mailHandler = () => {
    setSendMail(true);

    setTimeout(() => {
      setSendMail(false);
    }, 3000);
  };

  const getData = async (live) => {
    const result = await DetailEntity({ id: id, lang: lang, live: live });
    if (result.error) {
      setError({ error_active: true });
      setTimeout(() => setError({ redirect: true }), 5000);
    } else if (result.entity) {
      let search_id = result.entity.business_entity_id;
      await Axios.get(
        `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/menu/?lang=${lang}`
      )
        .then(async (res) => {
          if (!res.data.menu.active === true) {
            setError({ error_active: !res.data.menu.active });
            setTimeout(() => setError({ redirect: true }), 5000);

          }
          result.entity.business.relation_type = res.data.menu.relations;
          result.entity.business.relations =
            res.data.menu.relations > 0 || res.data.menu.relations === -1 ? true : false;
          result.entity.business.creads =
            res.data.menu.creads.length > 0 ? true : false;
          result.entity.business.cmps =
            res.data.menu.cmps.length > 0 ? true : false;
          result.entity.business.activities =
            res.data.menu.activities > 0 ? true : false;
          result.entity.business.brandslist =
            res.data.menu.brands > 0 ? true : false;

          if (!result.entity.has_subscription) { // If the entity has no subscription, disable the creads and cmps
            result.entity.business.cmps = false;
            result.entity.business.creads = false;
            result.entity.business.merken = false;
          }
          result.entity.business.contact.openinghours =
            res.data.menu.timetables > 0
              ? true
              : res.data.menu.timetables === -1
                ? "loading"
                : false;
          result.entity.business.contact.facilities =
            res.data.menu.facilities > 0 ? true : false;
          result.entity.business.contact.contacts =
            res.data.menu.persons > 0 ? true : false;

          if (result.entity.business.creads) {
            let children = [];
            for (let i = 0; i < res.data.menu.creads.length; i++) {
              let name =
                res.data.menu.creads[i][`name_${lang}`] ||
                res.data.menu.creads[i].name_nl ||
                res.data.menu.creads[i].name_fr;
              children.push(name);
            }
            result.entity.business.creadsChildren = children;
          }

          if (result.entity.business.cmps) {
            let children = [];
            for (let i = 0; i < res.data.menu.cmps.length; i++) {
              // let name = res.data.menu.cmps[i].name;
              let name =
                res.data.menu.cmps[i][`name_${lang}`] ||
                res.data.menu.cmps[i].name_nl ||
                res.data.menu.cmps[i].name_fr;
              children.push(name);
            }
            result.entity.business.cmpsChildren = children;
          }


          // Get the names of the ENT / EST
          await Axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/denominations/?lang=${lang}`
          )
            .then((res) => {
              result.entity.enterprise_name = res.data.denominations.official_name;
              result.entity.establishment_name = res.data.denominations.name;
              result.entity.registration = res.data.denominations.registration
              result.entity.fsma = res.data.denominations.fsma
              result.entity.itaa = res.data.denominations.itaa

              if (
                res.data.denominations.name &&
                res.data.denominations.official_name.toLowerCase() === res.data.denominations.name.toLowerCase()
              ) {
                // result.entity.name = res.data.denominations.official_name;
                result.entity.name = res.data.denominations.name;
              } else {
                result.entity.name = res.data.denominations.name
                  ? res.data.denominations.name
                  : res.data.denominations.official_name;
              }

              result.entity.juridical_form = res.data.denominations.juridical_form;
              result.entity.hide_abbreviation_in_front_end = false;

              result.entity.link_to_bp = `${id.replace(/(FrontBusiness-)+/g, "")}/${res.data.denominations.name ?
                res.data.denominations.name.toLocaleLowerCase().split(/[\s/]/).join("-")
                : res.data.denominations.official_name.toLocaleLowerCase().split(/[\s/]/).join("-")
                }`;

              result.entity.vat_number = result.entity.link_to_bp
                .slice(0, 12)
                .replace(/\./g, "");
              result.entity.establishment_number = search_id;
            })
            .catch((error) => {
              console.log(error);
            });

          // Get the address of the ENT / EST
          await Axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/address/?lang=${lang}`
          )
            .then((res) => {
              let main_address = res.data.address;
              result.entity.address = {};
              if (main_address && main_address.streetname) {
                result.entity.address.lat = main_address.latitude
                  ? String(main_address.latitude)
                  : "";
                result.entity.address.long = main_address.longitude
                  ? String(main_address.longitude)
                  : "";
                result.entity.address.postal = main_address.postal_code
                  ? main_address.postal_code
                  : "";
                result.entity.address.municipality = main_address.municipality
                  ? main_address.municipality
                  : "";
                result.entity.address.sub_municipality = main_address.sub_municipality
                  ? main_address.sub_municipality
                  : "";
                result.entity.address.street = main_address.streetname;
                result.entity.address.number = main_address.house_number;
                result.entity.address.box = main_address.box_number;
                result.entity.address.extra_info = main_address.extra_address_info;
                if (result.entity.juridical_form) {
                  result.entity.address.rpr_court = main_address.rpr_court;
                  result.entity.address.rpr_division = main_address.rpr_division;
                  result.entity.address.rpr_lang = main_address.rpr_lang;
                }

                if (
                  result.entity.address.municipality ===
                  result.entity.address.sub_municipality
                ) {
                  result.entity.address.sub_municipality = "";
                }
                result.entity.address.line_1 = `${result.entity.address.street} ${result.entity.address.number
                  }${result.entity.address.box && result.entity.address.box !== "None"
                    ? `/${result.entity.address.box}`
                    : ""
                  }`;
                result.entity.address.line_2 = `
                    ${result.entity.address.postal} 
                    ${result.entity.address.sub_municipality ? result.entity.address.sub_municipality : result.entity.address.municipality} 
                    ${result.entity.address.municipality.toLocaleLowerCase() !== result.entity.address.sub_municipality.toLocaleLowerCase() ? result.entity.address.sub_municipality ? `(${result.entity.address.municipality})` : "" : ``}
                    `;
              } else {
                result.entity.address.line_1 = translate('disabled_by')
                result.entity.address.line_2 = translate('disabled_by_2')
              }
            })

            .catch((error) => {
              console.log(error);
            });

          if (result.entity.address) {
            if (
              (!result.entity.address.long && !result.entity.address.lat) ||
              result.entity.address.long === "0.000000000000000" ||
              result.entity.address.lat === "0.000000000000000"
            ) {
              // remove the code below when we get Long / lat with the api endpoint
              await Axios.get(
                `https://nominatim.openstreetmap.org/search?q=${result.entity.address.line_1}%20${result.entity.address.municipality}&format=json`
              )
                .then((res) => {
                  if (result.entity) {
                    result.entity.address.lat =
                      res.data.length > 0 && res.data[0].lat;
                    result.entity.address.long =
                      res.data.length > 0 && res.data[0].lon;
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }

          if (result.entity.business.contact.openinghours) {
            let openinghours_model = require("../models/OpeninghoursModel").default;
            await Axios.get(
              `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/timetables/?lang=${lang}`
            )
              .then((res) => {
                result.entity.openinghours = openinghours_model(
                  res.data,
                  lang,
                  translate
                );
              })
              .catch((error) => console.log(error));
          }
          let logo_model = require("../models/BpLogoModel").default;

          await Axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/logos/?lang=${lang}`
          )
            .then((res) => {
              result.entity.logos = logo_model(res.data, lang);
              setEntity({
                ...entity,
                data: result.entity,
              });
            })
            .catch((error) => console.log(error));

          let marker_model = require("../models/BpMarkerModel").default;

          await Axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/markers/?lang=${lang}`
          )
            .then((res) => {
              result.entity.markers = marker_model(res.data, lang);
              setEntity({
                ...entity,
                data: result.entity,
              });
            })
            .catch((error) => console.log(error));

          // let marker_model = require("../models/BpMarkerModel").default;
          // await Axios.get(
          //   `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/markers/?lang=${lang}`
          // )
          //   .then((res) => {
          //     // Fetch only the first marker from the processed markers
          //     const processedMarkers = (marker_model(res.data, lang) || []).slice(1, 2);
 

          //     result.entity.markers = processedMarkers;
          //     setEntity({
          //       ...entity,
          //       data: result.entity,
          //     });
          //   })
          //   .catch((error) => console.log(error));
          



          let contact_model = require("../models/BpContactModel").default;
          await Axios.get(
            `${env.REACT_APP_BASE_MEDIA_URL}/core/api/business/${search_id}/contacts/?lang=${lang}`
          )
            .then((res) => {
              result.entity.social_media = contact_model(
                res.data,
                lang
              ).social_media;

              result.entity.telephone = contact_model(res.data, lang).telephone;
              result.entity.fax = contact_model(res.data, lang).fax;
              result.entity.cellphone = contact_model(res.data, lang).mobile_phone;
              result.entity.website = contact_model(res.data, lang).website;
              result.entity.registration_numbers = contact_model(res.data, lang).registration_numbers;
              if (result.entity.registration) { result.entity.registration_numbers.push({ type: 'Registration', number: result.entity.registration }) }
              if (result.entity.fsma) { result.entity.registration_numbers.push({ type: 'FSMA', number: result.entity.fsma }) }
              if (result.entity.itaa) { result.entity.registration_numbers.push({ type: 'ITAA', number: result.entity.itaa }) }
              setEntity({
                ...entity,
                data: result.entity,
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          console.log(error);
        });
      setEntity({
        ...entity,
        data: result.entity,
        views: [
          {
            active: result.entity.business.page,
            route: translate("contact_url"),
            title: translate("contact_and_opening_hours"),
          },
          {
            active: result.entity.business.creads,
            route: translate("our_story_url"),
            title: translate("our_story"),
            children: result.entity.business.creadsChildren,
          },
          {
            active: result.entity.business.videos,
            route: translate("videos_url"),
            title: translate("videos"),
          },
          {
            active: result.entity.business.cmps,
            route: translate("digital_display_url"),
            title: translate("promos_and_magazines"),
            children: result.entity.business.cmpsChildren,
          },
          {
            active: result.entity.business.brandslist,
            route: translate("brands_url"),
            title: translate("brands"),
          },
          {
            active: result.entity.business.relations,
            route: "locaties-op-kaart",
            title: "Locaties op kaart",
          },
          {
            active: result.entity.business.activities,
            route: translate("activities_url"),
            title: translate("activities"),
          },
        ],
      });
    }

    const bannersResponse = await fetchAdvertisementsForEstablishment(result.entity.establishment_number);
    const banners = bannersResponse.map(banner => banner.advertisement_banner);
    setAdvertisementBanners(banners);
    setLoadingAds(false);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let live = useQuery().get("live") === "true";
  let showMailForm = useQuery().get("mail") === "true";
  useEffect(() => {
    let expire_date = new Date().getTime() + 86400000;
    // let expire_date = new Date().getTime() + 10000;
    // if live has been added to the url, store it in a cookie to make realtime get requests

    if (live) {
      store.set("livePreview", true, expire_date);
    }
    // let live = props.match && props.match.params.live === 'live' ? true : false
    // console.log("isLive:", store.get("livePreview"));

    // props.match && props.match.params.live && store.set('livePreview', true, new Date().getTime() + 1)
    // let live = props.match && props.match.params.live ? true : false
    getData(store.get("livePreview"));

    window.scrollTo({ top: "0" });

    if (props.history && !prevPath) {
      // console.log(props.history)
      // if (!props.history.location.state || props.history.location.state && props.history.location.state.prevPath.includes('business') && props.location.pathname.includes('business')) {
      // 	setPrevPath('/')
      // }
      // else {
      // 	let catString = ''
      // 	if (store.get('osn-cat')) {
      // 		catString = `?category=${store.get('osn-cat')}`
      // 	}
      // 	else if (categoryID) { categoryID = `?category=${categoryID}` }
      // 	let filterString = serviceFilter.length > 0 ? `${categoryID ? '&' : '?'}service=${serviceFilter}` : ''
      // 	let prevString = props.history.location.pathname && props.location.state ? props.location.state.prevPath : ''

      // 	setPrevPath(prevString + catString + filterString)
      setPrevPath(store.get("prevPath"));

      // }
    }
  }, [live]);

  const hist = useHistory();
  const querry = useQuery();

  const settings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    dots: false,
    infinite: true,
    initialSlide: 0,
    lazyload: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    variableWidth: true,
    pauseOnhover: true,
    swipe: false,
  };

  const drawerHandler = (e) =>
    setTimeout(() => {
      setDrawer(e);
    }, 100);
  let enterpriseName = entity.data.name
    ? entity.data.name
    : entity.data.juridical_form
      ? entity.data.enterprise_name + " " + entity.data.juridical_form
      : entity.data.enterprise_name;



  return (
    <React.Fragment>
      {sendMail && (
        <div className="success_badge">
          Email werd succesvol verzonden{" "}
          <Icon name="Close" onClick={() => setSendMail(false)} />
        </div>
      )}
      <Redirects {...props} entity={entity} page="bp" />
      {error.error_active && (
        <div className="redirect_message_wrapper">
          <span className="redirect_message">
            <span className="redirect_sorry">{translate("we_are_sorry")}</span>
            <span>
              {translate("enterprise_cannot_be_found_anymre")}{" "}
              <Icon name="Sad" />
            </span>
            <span className="redirect_home">
              {translate("redirecting_you_to_home")}
            </span>
            <Link to={prevPath ? prevPath : "/"} className="redirect_button">
              {translate(
                store.get("prevPath") ? "back_to_results" : "go_back_to_home"
              )}
            </Link>
          </span>
        </div>
      )}
      {!error.redirect ? (
        <div
          className="Environment"
          onTouchEnd={() => drawerHandler(false)}
          style={{
            filter: map.show || error.error_active ? "blur(5px)" : null,
          }}
        >
          {/* Setup the business meta tags. */}
          <Meta
            description={
              entity.data.slogan
                ? `${entity.data.name
                  ? entity.data.name
                  : entity.data.enterprise_name
                }: ${entity.data.slogan}`
                : ""
            }
            latitude={entity.data.lat}
            logo={entity.data.logo}
            marker={entity.data.marker}
            longitude={entity.data.long}
            municipality={
              entity.data.address ? entity.data.address.municipality : ""
            }
            postal_code={entity.data.address ? entity.data.address.postal : ""}
            title={`${entity.data.establishment_name
              ? entity.data.establishment_name
              : entity.data.enterprise_name
              } ${translate("business_page")}`}
          />

          {/* Insert the navigation */}
          <Navigation background Zindex={Zindex} {...props} />

          {/* Business page */}
          <div className="bp">
            {/* Top of the business page */}
            <div
              className={`bpTop ${Zindex && "active"}`}
              onTouchEnd={() => setZindex(true)}
              onClick={() => setZindex(true)}
              onMouseOver={() => setZindex(true)}
            >
              <div className="bpName">
                {entity.data.enterprise_name && (
                  <h1 title={enterpriseName}>{enterpriseName}</h1>
                )}
                <a
                  className="backToResults"
                  href={prevPath ? prevPath : "../../../"}
                >
                  <Icon name="ArrowLongLeft" />
                  {store.get("prevPath")
                    ? translate("back_to_results")
                    : translate("go_back_to_home")}
                </a>
              </div>

              {/* Insert the search bar */}
              <Suspense fallback={<div></div>}>
                <SearchBar size="small" page="bp" />
              </Suspense>
            </div>
            <div
              className={`bpWrapper ${drawer && "active"}`}
              onClick={() => {
                drawer && drawerHandler(false);
                setZindex(false);
              }}
            >
              {/* Load in social media */}
              {entity.data.social_media &&
                entity.data.social_media.length > 0 && (
                  <SocialMedia
                    openMail={showMailForm}
                    data={entity.data.social_media}
                    lang={lang}
                    id={entity.data.business_entity_id}
                  />
                )}
              <div className={`bpMenu ${drawer && "active"}`}>
                <div className="bpLogo">
                  {entity.data.logos &&
                    entity.data.logos.length > 0 &&
                    entity.data.logos.length > 1 ? (
                    <Slider {...settings}>
                      {entity.data.logos.map((res, index) => (
                        <div
                          key={index}
                          className="bpLogo inner"
                          style={{ padding: "0 15px" }}
                        >
                          <img
                            src={res.logo}
                            alt={`Logo ${entity.data.enterprise_name} ${entity.data.juridical_form}`}
                            title={`Logo ${entity.data.enterprise_name} ${entity.data.juridical_form}`}
                          />
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <img
                      src={
                        entity.data && entity.data.logos && entity.data.logos[0]
                          ? entity.data.logos[0].logo
                          : Placeholder
                      }
                      alt={`Logo ${entity.data.name}`}
                      title={`Logo ${entity.data.name}`}
                    />
                  )}
                </div>

                <div className="bpEntrepreneurNameMobile">
                  {entity.data.name && (
                    <h1 title={entity.data.name}>{entity.data.name}</h1>
                  )}
                </div>
                <div
                  className="bpMenuMobile"
                  onClick={() => drawerHandler(true)}
                >
                  <Icon name="MenuFill" />
                </div>
                <ul
                  className="bpMenuItems"
                  style={{ right: drawer ? "0" : "-300px" }}
                >
                  {entity.views.map(
                    (view, index) =>
                      view.active === true && (
                        <li
                          className={mod === view.route ? "active" : ""}
                          key={index}
                        >
                          <Link
                            onClick={() => setBpIndex("all")}
                            className={mod === view.route ? "active" : ""}
                            to={`/business/${id}/${entity.data.establishment_name
                              ? entity.data.establishment_name
                                .toLocaleLowerCase()
                                .split(/[\s/]/)
                                .join("-")
                              : entity.data.enterprise_name
                                .toLocaleLowerCase()
                                .split(/[\s/]/)
                                .join("-")
                              }/${view.route}`}
                          >
                            {view.title}{" "}
                            {view.children &&
                              view.children.length > 1 &&
                              `(${view.children.length})`}
                          </Link>
                          {view.children && view.children.length > 1 && (
                            <div
                              className={`item_wrapper ${mod === view.route ? "active" : ""
                                }`}
                              style={{
                                height:
                                  mod === view.route
                                    ? `${32 * view.children.length}px`
                                    : "0",
                              }}
                            >
                              {view.children.map((title, i) => (
                                <span
                                  onClick={() => setBpIndex(i)}
                                  key={i}
                                  className={`child ${bpIndex === i ? "active" : ""
                                    }`}
                                  to={`/business/${id}/${entity.data.establishment_name
                                    ? entity.data.establishment_name
                                      .toLocaleLowerCase()
                                      .split(/[\s/]/)
                                      .join("-")
                                    : entity.data.enterprise_name
                                      .toLocaleLowerCase()
                                      .split(/[\s/]/)
                                      .join("-")
                                    }/${view.route}`}
                                >
                                  {title}
                                </span>
                              ))}
                            </div>
                          )}
                        </li>
                      )
                  )}
                </ul>
              </div>
              {/* {entity.views.map((view, index) => view.active && view.route === mod && view.component({ key: index, id: id, lang: lang }))} */}
              {entity.data.business_entity_id &&
                props.match.params.mod === "contact" && (
                  <Contact
                    setSendMail={(e) => mailHandler(e)}
                    {...props}
                    lang={lang}
                    entity_id={entity.data.business_entity_id}
                    tab={contactTab}
                    setTab={(e) => setContactTab(e)}
                    contactView={contactView}
                    setContactView={(e) => setContactView(e)}
                    // Booleans for activating the 3 tabs in contact (OHs, Facilities, Persons)
                    parts={entity.data.business.contact}
                    // Needed data for the contactBlock
                    entity={entity.data}
                    services={facilities}
                    setServices={(e) => setFacilities(e)}
                    contacts={persons}
                    setContacts={(e) => setPersons(e)}
                  />
                )}
              {entity.data.business_entity_id &&
                props.match.params.mod === "locaties-op-kaart" && (
                  <Relations
                    relation_type={entity.data.business.relation_type === -1 ? 1 : 0}
                    id={entity.data.business_entity_id}
                    lang='nl'
                    relations={relations}
                    setRelations={setRelations}
                  />
                )}
              {entity.data.business_entity_id &&
                (props.match.params.mod === "ons-verhaal" ||
                  props.match.params.mod === "notre-histoire") && (
                  <Suspense
                    fallback={
                      <div className="loadingScreen">
                        <Icon name="Loading" animated />
                      </div>
                    }
                  >
                    <CurrentOffers
                      {...props}
                      id={entity.data.business_entity_id}
                      lang={lang}
                      creadCollections={creadCollections}
                      setCreadCollections={(e) => setCreadCollections(e)}
                      bpIndex={bpIndex}
                    />
                  </Suspense>
                )}
              {entity.data.business_entity_id &&
                props.match.params.mod === "promos-magazines" && (
                  <Suspense
                    fallback={
                      <div className="loadingScreen">
                        <Icon name="Loading" animated />
                      </div>
                    }
                  >
                    <DigitalDisplay
                      params={params}
                      bpIndex={bpIndex}
                      id={entity.data.business_entity_id}
                      lang={lang}
                      cmpsCollections={cmpsCollections}
                      setCmpsCollections={(e) => setCmpsCollections(e)}
                      name={enterpriseName
                        .replace(/\ /g, "-")
                        .replace("ë", "e")}
                      url={
                        entity.data.atmaker_id
                          ? `https://www.catalogusnetwerk.be/nl/${entity.data.name.replaceAll("ë", "e").replaceAll(" ", "-")}/${entity.data.atmaker_id}`
                          : "https://www.catalogusnetwerk.be"
                      }
                      url_catalogue={`https://www.catalogusnetwerk.be/business/${id}`}
                      url_promonetwork={`https://www.promonetwerk.be/business/${id}`}
                    />
                  </Suspense>
                )}
              {entity.data.business_entity_id &&
                (props.match.params.mod === "merken" ||
                  props.match.params.mod === "marques") && (
                  <Suspense
                    fallback={
                      <div className="loadingScreen">
                        <Icon name="Loading" animated />
                      </div>
                    }
                  >
                    <Brands
                      id={entity.data.business_entity_id}
                      lang={lang}
                      brands={brands}
                      setBrands={(e) => setBrands(e)}
                      vat={id}
                    />
                  </Suspense>
                )}
              {entity.data.business_entity_id &&
                (props.match.params.mod === "activiteiten" ||
                  props.match.params.mod === "activités") && (
                  <Suspense
                    fallback={
                      <div className="loadingScreen">
                        <Icon name="Loading" animated />
                      </div>
                    }
                  >
                    <ActivitiesServices
                      key={props.key}
                      id={entity.data.business_entity_id}
                      template={1}
                      lang={lang}
                      activities={activities}
                      has_subscription={entity.data.has_subscription}
                      setActivities={(e) => setActivities(e)}
                    />
                  </Suspense>
                )}
              {/* Conditionally render vertical line and advertisements */}
              {advertisementBanners.length > 0 && !loadingAds && (
                <>
                  <div className="verticalLine" style={{ marginLeft: '5px', marginRight: '5px' }}></div>

                  <div className="advertisementBannersBusinessPageContainer">
                    <div className="advertisementBannersForDesktop" style={{ marginRight: '0px' }}>
                      {advertisementBanners.map((ad, index) => (
                        <AdvertisementCard key={index} banner={ad} forBusinessPage={true} />
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

          </div>



          {/* Footer */}
          <Footer />
        </div>
      ) : (
        <Redirect to={prevPath ? prevPath : "/"} />
      )}
    </React.Fragment>
  );
};

export default AlternateBusinessPage;
